import { useEffect } from "react";

export const PermissionState = {
  UNDEFINED: 1,
  GRANTED: 2,
  PROMPT: 3,
  DENIEND: 4
};

const useLocation = (onSuccess, onError, onPermissionStatusChange) => {
  let permissionState = PermissionState.UNDEFINED;

  const success = position => {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    onSuccess({ latitude, longitude, position });
  };

  const error = error => {
    let errorCode = "location.error.unknown";

    if (error && error.code) {
      const errorMapping = {
        1: "location.error.userDenied"
      };

      errorCode = errorMapping?.[error.code] ?? "location.error.unavailable";
    }

    onError(errorCode);
  };

  const getCurrentPosition = () => {
    navigator.geolocation.getCurrentPosition(success, error);
  };

  useEffect(() => {
    async function getGeoPermissions() {
      if (!navigator.permissions) {
        return;
      }

      const { rawState } = await navigator.permissions.query({
        name: "geolocation"
      });

      let state;

      switch (rawState) {
        case "granted":
          state = PermissionState.GRANTED;
          break;
        case "denied":
          state = PermissionState.DENIEND;
          break;
        case "prompt":
          state = PermissionState.PROMPT;
          break;
        default:
          state = PermissionState.UNDEFINED;
      }

      onPermissionStatusChange(state);
    }

    getGeoPermissions();
  }, [onError, onPermissionStatusChange, onSuccess]);

  return {
    getCurrentPosition,
    isLocationSupported: !!navigator.geolocation,
    permissionState
  };
};

export default useLocation;
